<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        用户反馈
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column width="100" align="center" prop="id" label="编号"></el-table-column>
        <el-table-column prop="mobile" width="160" label="联系电话" align="center"></el-table-column>
        <el-table-column prop="title" label="标题" align="center"></el-table-column>
        <el-table-column prop="create_date" label="时间" align="center"></el-table-column>
        <el-table-column label="操作" width="150" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="red(scope.row.id)" class="button1">查看</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col :span="5">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            >1</el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 添加用户 -->
    <el-dialog title="反馈详情" :visible.sync="dialogFormVisible1" width="33%">
      <el-form>
        <el-form-item label="联系电话:">
          <span style="width:356px;color: #0099ff;">{{moblie}}</span>
        </el-form-item>
        <el-form-item label="　　标题:">
          <span style="width:356px;color: #0099ff;">{{title}}</span>
        </el-form-item>
        <el-form-item label="　　时间:">
          <span style="width:356px;color: #0099ff;">{{create_date}}</span>
        </el-form-item>
        <el-form-item label="　　图片:">
          <!-- <el-input style="width:356px" v-model="images" autocomplete="off"></el-input> -->
          <img width="200" style="order: 1px solid #DCDFE6;" :src="serve+'' + images" alt />
        </el-form-item>
        <el-form-item label="　　内容:">
          <span style="color: #0099ff;">{{content}}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      token: "",
      username: "",
      page: null,
      total: 0,
      tableData: [],
      dialogFormVisible1: false,
      moblie: "",
      title: "",
      images: "",
      content: "",
      create_date: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 4;
    this.$store.state.leftTitle = "用户反馈";
    this.geting();
  },
  methods: {
    red(id) {
      this.dialogFormVisible1 = true;
      this.axios
        .get(this.serve + "/admin/user_feedback_detail", {
          params: {
            username: this.username,
            token: this.token,
            id
          }
        })
        .then(res => {
          var json = res.data.data;
          this.moblie = json.mobile;
          this.title = json.title;
          this.images = json.images;
          this.content = json.content;

          var time = json.create_date;
          var timeNew = new Date(parseInt(time) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ");
          json.create_date = timeNew;
          this.create_date = json.create_date;
        });
    },

    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
    },

    geting(page) {
      //请求数据
      this.token = this.$cookies.get("token");
      this.username = this.$cookies.get("username");
      this.axios
        .get(this.serve + "/admin/user_feedback", {
          params: {
            username: this.username,
            token: this.token,
            page: page
          }
        })
        .then(res => {
          this.tableData = [];
          if (res.data.status == "success") {
            var json = res.data.data;
            this.page = json.page;
            this.total = json.total;
            for (var key in json.results) {
              this.tableData.push(json.results[key]);
              var time = json.results[key].create_date;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json.results[key].create_date = timeNew;
            }
          } else {
            if (res.data.msg == "无权访问") {
              this.role = false;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>